import { instance } from "api/apiBase";

const api = {
  login: async (email, password) => {
    return (
      await instance.post("/portal/v1/auth/with_password", {
        email,
        password
      })
    ).data;
  },
  checkAuth: async () => {
    return (await instance.get("/portal/v1/auth")).data;
  },
  logout: async () => {
    return (await instance.delete("/portal/v1/auth")).data;
  },
  resetPassword: async (email) => {
    return (await instance.post(`/portal/v1/reset_password`, { email })).data;
  }
};

export const logout = async () => {
  return (await instance.delete("/portal/v1/auth")).data;
};

export const changePassword = async (oldPassword, newPassword) => {
  return (
    await instance.patch(`/portal/v1/users/change_password`, {
      password: oldPassword,
      new_password: newPassword
    })
  ).data;
};

export default api;
